module.exports = __webpack_public_path__ + "static/media/p2_10.006faa33.png";